<template>
  <div class="body">
      <Headtow  @sou="sou"></Headtow>
      <Headthree></Headthree>
      <div id="w-center">
        <div class="h-30"></div>
        <!-- 左侧 -->
        <div class="w-products">
          <p class="w-products-title">{{info.title}}</p>

          <p class="w-products-i">
            <i class="el-icon-s-custom"></i>
            <span class="w-products-i-name">{{info.username}}</span>&nbsp;&nbsp;&nbsp;&nbsp;{{info.create_time}}&nbsp;&nbsp;&nbsp;&nbsp;浏览{{info.set}}
            <span class="w-products-i-sc">
              <!-- <i class="el-icon-star-on"></i>收藏 -->
              <span class="right" v-if="info.sc > 0"  @click="sc(info.id,1)"><img src="../../static/img/sc2.png" alt="" class="zan"> 取消收藏</span>
              <span class="right" v-else @click="sc(info.id,0)"><img src="../../static/img/sc1.png" alt="" class="zan"> 加入收藏</span>

              <span class="right" v-if="info.dz > 0"  @click="dz(info.id,info.userid,info.id,1)"><img src="../../static/img/zan2.png" alt="" class="zan"> 取消点赞</span>
              <span class="right" v-else @click="dz(info.id,info.userid,info.id,0)"><img src="../../static/img/zan1.png" alt="" class="zan"> 我要点赞</span>

            </span>
           </p>
           <div class="h-20" v-if="info.sp" ></div>
           <video v-if="info.sp"
                  v-bind:src="info.sp"
                  class="video-avatar "
                  controls="controls">
               您的浏览器不支持视频播放
           </video>
          <div id="content" class="content-text">
            {{info.content}}
          </div>
          <ul class="Integral-ul JobsCont-hd">
            <li class="px-right">{{info.count}}个回答
            <el-radio-group v-model="radio" @change="pxbut">
              <el-radio label="1">时间排序</el-radio>
              <el-radio label="2" >点赞量</el-radio>
              </el-radio-group>
            </li>
          </ul>

          <ul id="Jobs-content">
            <li  v-for="(item, index) in list" :key="item.id">
                <div class="Jobs_div1">
                  <img  v-if="item.headimgurl" :src="item.headimgurl"  />
                  <img src="../../static/img/indextj3.jpg" alt=""  v-else  />
                </div>
                <div class="Jobs_div3 Jobs_div3_left">
                  <p class="Jobs_div3_p3 Jobs_div3_p3_name">{{item.username}}</p>
                  <p class="Jobs_div3_p1"><a style="color: #ff6b02;">@{{item.huifuname}}</a> {{item.content}}</p>
                  <div class="demo-image__preview" v-if="item.picarrs">
                    <el-image
                      v-for="(ele,index) in item.picarrs" :key="index"
                      style="width: 100px; height: 100px;margin-right: 5px;"
                      :src="ele"
                      :preview-src-list="item.picarrs"
                      fit="cover">
                    </el-image>
                  </div>

                  <p class="Jobs_div3_p2 ov1"><span>发表于{{item.create_times}}</span>
                   <span style="cursor: pointer;" @click="huifu(item.userid,item.username,item.content,item.id)" ><i class="el-icon-chat-line-square hf-text" >回复</i></span>
                   <span style="cursor: pointer;" class="right" v-if="list[index].dz > 0"  @click="dz(info.id,item.userid,item.id,1,index,1)"><img src="../../static/img/zan2.png" alt="" class="zan"> 取消点赞（{{list[index].dznum}}）</span>
                   <span style="cursor: pointer;" class="right" v-else @click="dz(info.id,item.userid,item.id,0,index,1)"><img src="../../static/img/zan1.png" alt="" class="zan"> 我要点赞（{{list[index].dznum}}）</span>

                  </p>
                </div>
                <div class="clear"></div>
                  <div v-for="(items, indexs) in item.lists" :key="indexs" class="w-jia" v-show="item.isOpen || indexs < max">
                      <div class="Jobs_div1">
                        <img  v-if="items.headimgurl " :src="items.headimgurl"  />
                        <img src="../../static/img/indextj3.jpg" alt=""  v-else  />
                      </div>
                      <div class="Jobs_div3 Jobs_div3_left" style="width:88%;">
                        <p class="Jobs_div3_p3 Jobs_div3_p3_name">{{items.username}}</p>
                        <p class="Jobs_div3_p1"><a style="color: #ff6b02;">@{{items.huifuname}}</a> {{items.content}}</p>

                        <div class="demo-image__preview">
                          <el-image
                            v-for="(eles,index) in items.picarrs" :key="index"
                            style="width: 100px; height: 100px;margin-right: 5px;"
                            :src="eles"
                            :preview-src-list="items.picarrs"
                            fit="cover">
                          </el-image>
                        </div>

                        <p class="Jobs_div3_p2 ov1"><span>发表于{{items.create_times}}</span>
                        <span style="cursor: pointer;" @click="huifu(items.userid,items.username,items.content,item.id)" ><i class="el-icon-chat-line-square" >回复</i></span>
                        <span style="cursor: pointer;" class="right" v-if="list[index].lists[indexs].dz > 0"  @click="dz(info.id,items.userid,items.id,1,index,2,indexs)"><img src="../../static/img/zan2.png" alt="" class="zan"> 取消点赞（{{list[index].lists[indexs].dznum}}）</span>
                        <span style="cursor: pointer;" class="right" v-else @click="dz(info.id,items.userid,items.id,0,index,2,indexs)"><img src="../../static/img/zan1.png" alt="" class="zan"> 我要点赞（{{list[index].lists[indexs].dznum}}）</span>
                        </p>
                      </div>
                      <div class="clear"></div>
                  </div>
                  <div class="w-jia" v-show="item.lists.length > max">
                    <a v-show="!item.isOpen && item.lists.length > max" @click="item.isOpen = !item.isOpen" class="w-jia-color">查看更多（{{item.lists.length-max}}）</a>
                    <a v-show="item.isOpen && item.lists.length > max" @click="item.isOpen = !item.isOpen" class="w-jia-color">收起</a>
                  </div>

            </li>
          </ul>

          <div class="page">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="12"
              @current-change="handleCurrentChange"
              :total="total">
            </el-pagination>
          </div>


            <div class="content">
              <el-input
                class="textarea-ipt"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 6}"
                placeholder="我来回答 "
                v-model="content">
              </el-input>
              <div class="h-10"></div>

            <el-breadcrumb separator=" ">
              <el-breadcrumb-item>图片上传</el-breadcrumb-item>
             </el-breadcrumb>
            <div class="h-10"></div>
            <el-upload
              class="img-upload"
              title="上传图片"
              action="http://pc.zyjlfwpt.com/api.php/Upload/uploadcords"
              list-type="picture-card"
              :file-list="photoList"
              :before-upload="photoBeforeUpload"
              :on-preview="photoPreview"
              :on-remove="photoRemove"
              :on-success="photoSuccess">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible" append-to-body>
              <img width="100%" :src="dialogImageUrl" alt="" >
            </el-dialog>


              <div class="ProdCont-top-center-but">
                <el-button @click="jobshd(info.id)">提交回答</el-button>
              </div>
            </div>

        </div>
        <el-dialog title="回复" :visible.sync="huifus" @close='closeDialog'>
          <el-input
            class="textarea-ipt"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 6}"
            :placeholder="hname"
            v-model="content">
          </el-input>
          <div class="h-10"></div>
          <el-breadcrumb separator=" ">
            <el-breadcrumb-item>图片上传</el-breadcrumb-item>
          </el-breadcrumb>
          <div class="h-10"></div>
          <el-upload
            class="img-upload"
            title="上传图片"
            action="http://pc.zyjlfwpt.com/api.php/Upload/uploadcords"
            list-type="picture-card"
            :file-list="photoList"
            :before-upload="photoBeforeUpload"
            :on-preview="photoPreview"
            :on-remove="photoRemove"
            :on-success="photoSuccess">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="" >
          </el-dialog>


          <div class="h-10"></div>


          <div class="ProdCont-top-center-but">
            <el-button @click="jobshd(info.id,huifuuid,huidaid)">提交回复</el-button>
          </div>
        </el-dialog>

        <!-- 左侧结束 -->
        <!-- 右侧开始 -->
        <UserRight></UserRight>
        <!-- 右侧结束 -->
      </div>
       <div class="clear h-30"></div>
       <Foot></Foot>
  </div>

</template>

<script>
import headthree from '@/components/public/headthree.vue';
import foot from '@/components/public/foot.vue'
import userRight from '@/components/public/userRight.vue'
import headtow from '@/components/public/headtow.vue'
export default{
  data(){
    return {
      radio: '1',
      max: 3, // 默认最多显示的个数；最大行数*每行显示的个数 Number
      isOpen: false, // 是否展开全部信息的标识 Boolean 默认false
      huifus:false,
      loading:true,
      info:[],
      id:'1',
      content:'',
      page:1,
      total:0,
      form:{
        userid:'',
        fabuid:'',
        content:'',
        picarrs:'',
        huidaid:'',
      },
      list:[],
      huifuuid:'',
      huidaid:'',
      hname:'',
      hcontent:'',
      //  多图
      photoList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      picarrs:[],

    }
  },
  components: {
    'Headthree': headthree,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'UserRight': userRight,
    'Headtow': headtow,

  },
  mounted () {
    this.id = this.$route.query.id;
    this.recordapi();
  },
  methods:{
    sou(){
     this.keywords = this.$route.query.keyword
     console.log(this.keywords);
      this.recordapi();
    },
    pxbut(e){
      this.radio = e;
      this.recordapi();

    },


    // 多图上传
      photoBeforeUpload:function(file) {
        const isJPG = file.type === "image/jpeg" || file.type === "image/png";
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isJPG) {
    　　　　　this.$message.error("上传图片只能是 JPG 和 Png 格式!");
    　　　　　return false;
    　　　}
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 10MB!');
        }
        return isJPG && isLt2M;
      },
      photoRemove:function(file, fileList) {
        this.upload(fileList);
      },
      photoPreview:function(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      photoSuccess:function(response, file, fileList){
        this.upload(fileList);
      },
      upload:function(fileList){
        let that   = this;
        // let userid = this.$cookie.get('userid');
        console.log(fileList);
        var picarr = [];
        fileList.forEach((item, index) => {
          console.log(item.response)
          var mycars = new Array();
          mycars['name'] = index;
          if(item.response){
            mycars['url']  = item.response.path;
          }else{
            mycars['url']  = item.path;
          }
          picarr.push(mycars);
        })
        this.picarrs = picarr;
        console.log(picarr);

      },
      // 多图上传 结束


    closeDialog(){
      this.content ='';
      this.photoList = [];
      this.form.picarrs = [];
      this.picarrs = [];
    },


    handleAvatarSuccess(res, file) {
      console.log(res);
      console.log(file);
      // this.imageUrl = URL.createObjectURL(file.raw);
      // this.form.picurl = res.path;
    },


    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Products/JobsContent",{'id':that.id,'page':this.page,userid:userid,'px':this.radio}).then(res => {
          console.log(res);
          that.info= res.info;
          that.list = res.list.data;
          this.total = res.list.total
          this.loading = false
        });
    },
    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },
    // 收藏
    sc(e,zt){
      var that = this;
      var id = e;
      var zt = zt;
      console.log(zt);
      var userid = that.$cookieStore.getCookie('userid');

      if(userid==''){
        this.$message.error('请先登录');
        return;
      }
      that.$api.post("/Products/Jobssc",{'id':id,'userid':userid,zt:zt}).then(res => {
        console.log(res);
        if(res.code==1){
          if(zt==1){
            that.info.sc = 0;
          }else{
            that.info.sc = 1;
          }

          this.$message.success(res.msg);
        }

      });
    },

    // 点赞
    dz(ltid,dzid,e,zt,sc,type,indexs){   // dzid 代表给那个用户点赞
      var that = this;
      var id = e;
      var zt = zt;
      console.log(zt);
      var userid = that.$cookieStore.getCookie('userid');

      if(userid==''){
        this.$message.error('请先登录');
        return;
      }
      that.$api.post("/Products/Jobsdz",{'id':id,'userid':userid,zt:zt,'dzid':dzid,'ltid':ltid}).then(res => {
        console.log(res);
        if(res.code==1){
          console.log(type);
          if(type == 1){

            // 一级点赞
            if(that.list[sc].dz==1){
               that.list[sc].dz = 0;
               that.list[sc].dznum = that.list[sc].dznum-1 ;
            }else{
               that.list[sc].dz = 1;
               that.list[sc].dznum =that.list[sc].dznum+1 ; ;
            }

          // 二级点赞
          }else if(type == 2){
            if(that.list[sc].lists[indexs].dz==1){
               that.list[sc].lists[indexs].dz = 0;
               that.list[sc].lists[indexs].dznum = that.list[sc].lists[indexs].dznum-1 ;
            }else{
               that.list[sc].lists[indexs].dz = 1;
               that.list[sc].lists[indexs].dznum =that.list[sc].lists[indexs].dznum+1 ;
            }
          }else{
            // 普通点赞
            if(zt==1){
              that.info.dz = 0;
            }else{
              that.info.dz = 1;
            }
          }
          // that.list=[];
          // this.recordapi();
          this.$message.success(res.msg);
        }

      });
    },



    jobshd(id,huifuuid,huidaid){

      var that = this;
      var userid = that.$cookieStore.getCookie('userid');
      console.log(userid);
      if(userid==''){
        this.$message.error('请先登录');
        return;
      }

      that.form.userid = userid;   // 我自己；
      if(huifuuid){
         console.log(huidaid);
        that.form.huifuuid = huifuuid;
        that.form.status = 3;// 3是回复
         that.form.title = this.hcontent;
         that.form.huidaid = huidaid;
        if(that.content==''){
          this.$message.error('请输入回复内容');
          return;
        }
      }else{
         that.form.huifuuid = that.info.userid;  // 要回复你
         that.form.status = 2; // 2是回答
         that.form.title = that.info.title;
         if(that.content==''){
           this.$message.error('请输入回答内容');
           return;
         }
      }


      if( that.picarrs.length>0){
        that.form.picarrs = this.picarrs;
      }else{
         that.form.picarrs = '';
      }



      that.form.fabuid = that.id;   // 回复当前页面的发布id
      that.form.content = that.content;



      that.form.cid = that.info.cid;

      that.$api.post("/Products/jobsFabu",{data:this.form}).then(res => {
        console.log(res);
        this.$message.success(res.msg);
        that.content ='';
        this.huifus = false;
        this.photoList = [],
        this.form.picarrs = [],
        this.recordapi();

      });
    },
    huifu(huifuuid,hname,hcontent,huidaid){
      console.log(huidaid);
      this.huifus = true;
      this.hname = "@"+hname+"回复：";
      this.hcontent = hcontent;
      this.huifuuid = huifuuid;
      this.huidaid = huidaid;
    }

  },

 }
</script>



// WEBPACK FOOTER //
// src/components/JobsCont.vue